import { render, staticRenderFns } from "./salesList.vue?vue&type=template&id=2fd4f2aa&"
import script from "./salesList.vue?vue&type=script&lang=js&"
export * from "./salesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports